<template>
  <div
    id="search-anchor"
    class="container mx-auto my-3 px-2 flex flex-wrap items-center gap-2 justify-center dark:text-slate-100"
  >
    <button
      class="pill-button px-4 py-1.5 text-sm text-gray-300 hover:text-gray-100 rounded-full transition-all duration-200"
      @click="goToEvents"
    >
      {{ t("Events") }}
    </button>
    <button
      v-if="isLongEvents"
      class="pill-button px-4 py-1.5 text-sm text-gray-300 hover:text-gray-100 rounded-full transition-all duration-200"
      @click="goToActivities"
    >
      {{ t("Activities") }}
    </button>
    <button
      class="pill-button px-4 py-1.5 text-sm text-gray-300 hover:text-gray-100 rounded-full transition-all duration-200"
      @click="goToCalendar"
    >
      {{ t("Calendar") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent } from "vue";
import { ContentType } from "@/types/enums";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import RouteName from "@/router/name";
import { useIsLongEvents } from "@/composition/apollo/config";

const router = useRouter();
const route = useRoute();
const { isLongEvents } = useIsLongEvents();

const goToEvents = () => {
  router.push({
    name: RouteName.SEARCH,
    query: { contentType: ContentType.EVENTS },
  });
};

const { t } = useI18n({ useScope: "global" });
const goToActivities = () => {
  router.push({
    name: RouteName.SEARCH,
    query: { contentType: ContentType.LONGEVENTS },
  });
};

const goToCalendar = () => {
  router.push({ name: RouteName.EVENT_CALENDAR });
};
</script>

<style scoped lang="scss">
.pill-button {
  position: relative;
  background: rgba(31, 41, 55, 0.4);
  backdrop-filter: blur(8px);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 9999px;
    padding: 1px;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.08),
      rgba(255, 255, 255, 0.03)
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0.5;
  }

  &:hover {
    transform: translateY(-1px);
    background: rgba(42, 83, 89, 0.3);

    &::before {
      opacity: 1;
    }
  }
}
</style>
